<section class="w-100 p-3">
    <div class="row">
        <div class="col-md-6">
            <p class="mb-1"><small><b>Completitud del perfil:</b></small></p>
            <div class="progress mb-1">
                <div class="progress-bar" role="progressbar" [style.width]="percent + '%'" aria-valuemin="0" aria-valuemax="100">
                    {{percent}}%
                </div>
            </div>
            <a style="margin-left: 10px;" [routerLink]="'myAccount'"><b class="text-danger">Por favor completa tu perfil AQUÍ</b></a>
        </div>
    </div>
</section>